import { render } from "./404.vue?vue&type=template&id=246c5cab"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import exportComponent from "/Users/agostinodegirolamo/Dropbox/Mac/Documents/Progetti/TTRE/Rapportino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__